import moment from "moment";
import { isLikeMessage } from "common/helpers/isLike";

import isHiddenMessage from "common/helpers/isHiddenMessage";

export function commentToThread(
  comment: Vingle.Comment.IComment,
): Vingle.IThread<Vingle.Comment.IComment> {
  return {
    original: comment,
    id: comment.id,
    content: comment.content,
    user: comment.user,
    replyCount: comment.comments_count,
    createdAt:
      moment(comment.created_at, "YYYY-MM-DD HH:mm:ss Z").unix() * 1000,
    isEdited: comment.is_edited,
    isReply: comment.is_reply,
    isTop: comment.is_top,
    liked: comment.liked,
    likesCount: comment.likes_count,
    previewThreads:
      comment.preview_comments &&
      comment.preview_comments
        .map(preview => {
          return commentToThread(preview);
        })
        .reverse(),
    resource: comment.resource,
  };
}

export function messageToThread(
  message: Vingle.Talk.IMessage,
  currentUser: Vingle.User.IUser | null,
): Vingle.IThread<Vingle.Talk.IMessage> {
  return {
    id: message.id,
    content: message.content,
    user: message.user,
    original: message,
    replyCount: message.type === "thread" ? message.message_count : 0,
    createdAt: message.created_at * 1000,
    isEdited: message.created_at !== message.updated_at,
    isReply: message.type === "thread_reply",
    liked: isLikeMessage(message),
    likesCount: message.like_count,
    hidden: isHiddenMessage(message, currentUser),
    previewThreads:
      message.type === "thread"
        ? message.preview_messages.map(thread =>
            messageToThread(thread, currentUser),
          )
        : message.type === "message"
        ? []
        : undefined,
    resource: message.resource,
    isPosting: false,
  };
}

export function replyToThread(
  reply: Vingle.QnA.IReply,
): Vingle.IThread<Vingle.QnA.IReply> {
  return {
    original: reply,
    id: reply.id,
    content: reply.content,
    user: reply.author,
    createdAt: reply.created_at * 1000,
    isReply: true,
  };
}

export function answerToThread(
  answer: Vingle.QnA.IPostingAnswer,
): Vingle.IThread<Vingle.QnA.IAnswer> {
  return {
    original: answer,
    id: answer.id,
    content: answer.content,
    user: answer.author,
    replyCount: answer.reply_count,
    createdAt: answer.created_at * 1000,
    liked: Boolean(answer.relation && answer.relation.like),
    likesCount: answer.like_count,
    previewThreads: answer.preview_replies.map(reply => {
      return replyToThread(reply);
    }),
    isPosting: answer.isPosting,
    resource: answer.resource,
  };
}
